import { Component, OnInit, ViewChild, TemplateRef, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SignsService } from '@shared/services/signs.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { BaseService, ErrorService, UsersService } from '@shared/services';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { first, takeUntil } from 'rxjs/operators';
import { MenuItem } from 'primeng/api';
import swal from 'sweetalert2';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { MatHeaderRow, MatHeaderRowDef, MatTable, MatTableDataSource } from '@angular/material/table';

export type ExportFormat = 'excel' | 'pdf';
@Component({
  selector: 'app-user-groups',
  templateUrl: './user-groups.component.html',
  styleUrls: ['./user-groups.component.scss']
})
export class UserGroupsComponent implements OnInit, OnDestroy {
    subscription: Subscription = new Subscription();
    private _unsubscribeAll$ = new Subject<boolean>();

    items: MenuItem[];
    loading = true;
    constructor(
        private translate: TranslateService,
        public router: Router,
        public route: ActivatedRoute,
        private modalService: BsModalService,
        private _signservice: SignsService,
        private fb: FormBuilder,
        private _errorService: ErrorService,
         private baseService: BaseService,
         private userservice : UsersService
    ) {}

    searchValue = '';
    changeNewContant = false;
    laddaSearchProgress: boolean | number = false;

    userGroupsList = [];
    @ViewChild('exportModal', { static: true }) exportModal: TemplateRef<any>;
    @ViewChild('formAddEditModal', { static: true }) formModal: TemplateRef<any>;
    modalRef: BsModalRef | null;

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    displayedColumns: string[] = ['select', 'groupName', 'Status'];
    dataSource = new MatTableDataSource([]);
    selection = new SelectionModel(true, []);
    currentSign;
    formType = 'add';
    userGroupsForm: FormGroup;
    saveContant = false;
    userGroupId = '1';
    selectedcapacity = [];
    selectedStatus = 'Active';
    statusList = [{ name: 'All' }, { name: 'Active' }, { name: 'Inactive' }];
    actionStatus = null;
    actionsList = [{ name: 'Action' }, { name: 'Activate' }, { name: 'Delete' }, { name: 'Inactivate' }];
    newSign = false;
    Gridcongid = { grid: 'UserGroupsTbl', windowRoute: 'UserGroups' };
    selectAction() {
        if (this.actionStatus === 'Activate') {
            this.changeStatus('A');
        }
        if (this.actionStatus === 'Delete') {
            this.delete();
        }
        if (this.actionStatus === 'Inactivate') {
            this.changeStatus('NA');
        }
        this.actionStatus = null;
    }
    ngOnDestroy() {
        this._unsubscribeAll$.next(true);
        this._unsubscribeAll$.complete();
        // this.subscription.unsubscribe();
        if (this.modalRef) {
            this.modalRef.hide();
        }
    }
    applyfilterStatus() {
        if (this.selectedStatus === 'Active') {
            this.filterStatus(true);
        }
        if (this.selectedStatus === 'Inactive') {
            this.filterStatus(false);
        }
        if (this.selectedStatus === 'All') {
            this.filterStatus('');
        }
    }
    Editcapacity(row) {
        this.formType = 'edit';
        this.initForm();
        this.getById(row.groupId);
        this.openModal();
    }
    AddNewItem() {
        this.formType = 'add';
        this.initForm();
        this.openModal();
    }

    deleteSelected() {
        if (this.selection.selected.length == 0) {
            this.newMessage(60, 'error');
        } else {
            this.selectedcapacity = this.selection.selected;
            this.newMessage(9, 'delete');
        }
    }
    openModal() {
        const configs = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: ' modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
            animated: false
        };
        this.modalRef = this.modalService.show(this.formModal, configs);
    }
    closeAddEditModal() {
        if (!this.changeNewContant) {
            this.newSign = false;
            this.modalRef.hide();
        } else this.newMessage(144, 'ClosePopup');
    }
    ClosePopup() {
        this.newSign = false;
        this.modalRef.hide();
        this.changeNewContant = false;
    }

    closeanypopup(){
        this.modalRef.hide();
    }

    filterStatus(status) {
        const newList = [];
        this.dataSource = new MatTableDataSource(this.userGroupsList);

        if (status === '') {
        } else {
            this.dataSource.filteredData.forEach((element) => {
                if (element.isvalid === status) {
                    newList.push(element);
                }
            });
            this.dataSource = new MatTableDataSource(newList);
        }
        this.dataSource.sort = this.sort;

        this.applyFilter(this.searchValue);
    }
    getById(userGroupId) {
        this.userservice
            .getUserGroupById(userGroupId)
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe(
                (result) => {
                    this.currentSign = result.data;
                    const controls = this.userGroupsForm.controls;
                    Object.keys(controls).forEach((key) => {
                        if (this.currentSign[key] != null) {
                            this.userGroupsForm.get(key).setValue(this.currentSign[key]);
                        }
                        this.changeNewContant = false;
                    });
                },
                (error) => {}
            );
    }

    ngOnInit() {
       this.initializeMenuItems();
        this.getList();
        this.initForm();
        this.userGroupsForm.valueChanges.pipe(takeUntil(this._unsubscribeAll$)).subscribe((changes) => {
            this.changeNewContant = true;
        });

        this.subscription.add(
            this._errorService.currentAction
                .pipe(takeUntil(this._unsubscribeAll$))
                .subscribe((action) => this.actionMsg(action))
        );
    }

    getList() {
        this.searchValue = '';
        this.userservice
            .GetAllGroups()
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                this.userGroupsList = result.data;
                this.dataSource = new MatTableDataSource(this.userGroupsList);
                this.dataSource.sort = this.sort;
                this.loading = false;
                //  this.applyfilterStatus();
            });
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    checkboxLabel(row): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.email + 1}`;
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    private initForm(): void {
        this.userGroupsForm = this.fb.group({
            groupId: new FormControl(null),
            groupName: new FormControl(null, [Validators.required]),
            isValid: new FormControl(true)
        });
    }
    setTumbnail(data) {
        this.userGroupsForm.get('photo').setValue(data);
    }
    setFileName(data) {
        this.userGroupsForm.get('photo').setValue(data);
    }

    saveAddEditcapacity() {
        this.laddaSearchProgress = 1;
        const controls = this.userGroupsForm.controls;
        Object.keys(controls).forEach((key) => {
            controls[key].markAsTouched();
        });

        if (this.userGroupsForm.status === 'VALID') {
            this.saveContant = false;
            if (this.userGroupsForm.value.groupId == null) {
                this.userservice
                    .addUserGroup(this.userGroupsForm.value)
                    .pipe(takeUntil(this._unsubscribeAll$), first())
                    .subscribe(
                        (result) => {
                            if (result.isSuccess) {
                                // const dgwData = result.data;
                                this.newMessage(93, '');
                                this.changeNewContant = false;
                                this.closeAddEditModal();
                            } else {
                                this.newMessage(77, '');
                            }
                            this.getList();
                            this.laddaSearchProgress = false;
                        },
                        (error) => {
                            this.laddaSearchProgress = false;
                        }
                    );
            } else {
                this.userservice
                    .editUserGroup(this.userGroupsForm.value)
                    .pipe(takeUntil(this._unsubscribeAll$), first())
                    .subscribe(
                        (result) => {
                            if (result.isSuccess) {
                                // const dgwData = result.data;
                                this.newMessage(4, '');
                                this.changeNewContant = false;
                                this.closeAddEditModal();
                            } else {
                                this.newMessage(77, '');
                            }
                            this.getList();
                            this.laddaSearchProgress = false;
                            this.changeNewContant = false;
                            this.saveContant = false;
                        },
                        (error) => {
                            this.laddaSearchProgress = false;
                        }
                    );
            }
        } else {
            this.saveContant = true;
            window.scrollTo(0, 0);
            this.laddaSearchProgress = false;
            this.newMessage(3, '');
        }
        // this.modalRef.hide();
    }

    setCurrentcapacity() {
        this.delete();
    }
    delete() {
        // console.log(this.selectedcapacity.map((obj) => obj.groupId));
        this.userservice
            .deleteUserGroups(this.selectedcapacity.map((obj) => obj.groupId))
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe(
                (result) => {
                    if (result.isSuccess) {
                        this.newMessage(54, '');
                    } else {
                        this.newMessage(55, '');
                    }
                    this.selection = new SelectionModel(true, []);
                    this.getList();
                    this.laddaSearchProgress = false;
                    this.changeNewContant = false;
                    this.saveContant = false;
                },
                (error) => {
                    this.laddaSearchProgress = false;
                }
            );
    }
    changeStatus(data) {}

    actionMsg(data) {
        if (data !== '') {
            this[data]();
            this._errorService.action('');
        }
    }
    newMessage(id, action) {
        this._errorService.changeMessage({ id: id, action: action });
    }
    closeLocalizationPopup(localizationComponant) {
        localizationComponant.closeAddEditModal();
    }

    // new part 
      actionList = [
        { label: 'Delete', disabled: false },
      ];
 selectedAction: string | null = null;
          onActionChange(action: any) {
            switch (action.label) {
              case 'Delete':
                this.deleteSelected();
                break;
              default:
                break;
            }
             this.selectedAction = null;
          }


    //  Export(): void {
    //               const fileName = 'exported-data.xlsx';
    //               const dataToExport = this.dataSource.filteredData;
                
    //               // Optional: map only selected columns
    //               const exportData = dataToExport.map(item => ({
    //                 groupName : item.groupName
    //               }));
                
    //               const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    //               const workbook: XLSX.WorkBook = {
    //                 Sheets: { data: worksheet },
    //                 SheetNames: ['data']
    //               };
                
    //               const excelBuffer: any = XLSX.write(workbook, {
    //                 bookType: 'xlsx',
    //                 type: 'array'
    //               });
                
    //               const blob: Blob = new Blob([excelBuffer], {
    //                 type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    //               });
                
    //               FileSaver.saveAs(blob, fileName);
    //             }
                

                 filterList : any[] = ['Display All' , 'Active' , 'Inactive'];
    selectedDisplayAction: string = 'Display All';
  onFilterChange(filterValue: string) {
  if (!filterValue || filterValue === 'Display All') {
    this.selectedDisplayAction = 'Display All';
    this.dataSource.data = [...this.userGroupsList];
  } else if (filterValue === 'Active') {
    this.selectedDisplayAction = 'Active';
    this.dataSource.data = this.userGroupsList.filter(item => item.isValid === true);

  } else if (filterValue === 'Inactive') {
    this.selectedDisplayAction = 'Inactive';
    this.dataSource.data = this.userGroupsList.filter(item => item.isValid === false);
  }
}

   disableActivate = false;
disableInactivate = false;


updateActionAvailability() {
    const selected = this.selection.selected;
  
    if (!selected || selected.length === 0) {
      this.disableActivate = false;
      this.disableInactivate = false;
    } else {
      const allActive = selected.every(item => item.isValid === true);
      const allInactive = selected.every(item => item.isValid === false);
  
      if (allActive) {
        this.disableActivate = true;
        this.disableInactivate = false;
      } else if (allInactive) {
        this.disableActivate = false;
        this.disableInactivate = true;
      } else {
        this.disableActivate = true;
        this.disableInactivate = true;
      }
    }
      this.updateMenuItems();
  
    
  }

    initializeMenuItems() {
    this.items = [
      {
        label: this.translate.instant('Delete'),
        icon: 'pi pi-times',
        disabled: false,
        command: () => {
          this.deleteSelected();
        }
      },
      {
        label: this.translate.instant('Activate'),
        icon: 'pi pi-check',
        disabled: this.disableActivate,
        command: () => {
          this.activeSelectedCapacityUnits();
        }
      },
      {
        label: this.translate.instant('Deactivate'),
        icon: 'pi pi-ban',
        disabled: this.disableInactivate,
        command: () => {
          this.inactiveSelectedCapacityUnits();
        }
      }
    ];
  }


  updateMenuItems() {
    this.items = [
      {
        label: this.translate.instant('Delete'),
        icon: 'pi pi-times',
        disabled: false,
        command: () => {
          this.deleteSelected();
        }
      },
      {
        label: this.translate.instant('Activate'),
        icon: 'pi pi-check',
        disabled: this.disableActivate,
        command: () => {
          this.activeSelectedCapacityUnits();
        }
      },
      {
        label: this.translate.instant('Deactivate'),
        icon: 'pi pi-ban',
        disabled: this.disableInactivate,
        command: () => {
          this.inactiveSelectedCapacityUnits();
        }
      }
    ];
  }

           
         activeSelectedCapacityUnits() {
             let idsToActive: number[] = [];
         
             // Collect selected fixed asset IDs
             if (this.selection && this.selection.selected.length > 0) {
                 const capacitiestIds = this.selection.selected.map(item => item.groupId);
                 idsToActive = [...idsToActive, ...capacitiestIds];
             }
         
             // If there are IDs selected, confirm before inactivating
             if (idsToActive.length > 0) {
                 swal.fire({
                     title: `Are you sure you want to activate the selected items?`,
                     type: "question", //  Use 'type' for SweetAlert v1 or wrappers
                     showCancelButton: true,
                     confirmButtonText: "Yes",
                     cancelButtonText: "No",
                     confirmButtonColor: "#6FBDC1"
                 }).then((result) => {
                     if (result.value) {
                         this.userservice
                             .activeUserGroups(idsToActive)
                             .pipe(takeUntil(this._unsubscribeAll$), first())
                             .subscribe(
                                 (result) => {
                                     if (result.isSuccess) {
                                         this.newMessage(56, '');
                                     } else {
                                         this.newMessage(57, '');
                                     }
         
                                     // Reset UI states
                                     this.selection = new SelectionModel(true, []);
                                     this.getList();
                                     this.laddaSearchProgress = false;
                                     this.changeNewContant = false;
                                     this.saveContant = false;
         
                                     // Optionally reset the action selection
                                     this.selectedAction = null;
                                 },
                                 (error) => {
                                     this.laddaSearchProgress = false;
                                 }
                             );
                     }
                 });
             }
         }
         
  
          inactiveSelectedCapacityUnits() {
            let idsToInactive: number[] = [];
        
            // Collect selected fixed asset IDs
            if (this.selection && this.selection.selected.length > 0) {
                const capacitiestIds = this.selection.selected.map(item => item.groupId);
                idsToInactive = [...idsToInactive, ...capacitiestIds];
            }
        
            // If there are IDs selected, confirm before inactivating
            if (idsToInactive.length > 0) {
                swal.fire({
                    title: `Are you sure you want to inactivate the selected items?`,
                    type: "question", // ✅ Use 'type' for SweetAlert v1 or wrappers
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    confirmButtonColor: "#6FBDC1"
                }).then((result) => {
                    if (result.value) {
                        this.userservice
                            .InactiveUserGroups(idsToInactive)
                            .pipe(takeUntil(this._unsubscribeAll$), first())
                            .subscribe(
                                (result) => {
                                    if (result.isSuccess) {
                                        this.newMessage(56, '');
                                    } else {
                                        this.newMessage(57, '');
                                    }
        
                                    // Reset UI states
                                    this.selection = new SelectionModel(true, []);
                                    this.getList();
                                    this.laddaSearchProgress = false;
                                    this.changeNewContant = false;
                                    this.saveContant = false;
        
                                    // Optionally reset the action selection
                                    this.selectedAction = null;
                                },
                                (error) => {
                                    this.laddaSearchProgress = false;
                                }
                            );
                    }
                });
            }
        }

          async Export(format: ExportFormat = 'excel'): Promise<void> {
          const dataToExport = this.dataSource.filteredData;
          
          // Optional: map only selected columns
          const exportData = dataToExport.map(item => ({
            Name: item.groupName,
            Status: item.isValid ? 'Active' : 'Inactive'
          }));
        
          if (format === 'excel') {
            await this.exportToExcel(exportData);
          } else if (format === 'pdf') {
            await this.exportToPDF(exportData);
          }
        }
        
        private async exportToExcel(data: any[]): Promise<void> {
          const fileName = 'UserGroups.xlsx';
          
          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
          const workbook: XLSX.WorkBook = {
            Sheets: { data: worksheet },
            SheetNames: ['data']
          };
          
          const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
          });
          
          const blob: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
          });
          
          await this.saveFile(blob, fileName, 'Excel files', {
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
          });
        }
        
        private async exportToPDF(data: any[]): Promise<void> {
          const fileName = 'UserGroups.pdf';
          
          // Create PDF document
          const doc = new jsPDF();
          
          // Add title
          doc.setFontSize(16);
          doc.text('UserGroups Exported Data Report', 14, 20);
          
          // Add date
          doc.setFontSize(10);
          doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);
          
          // Prepare table data
          const tableColumns = ['Name', 'Status'];
          const tableRows = data.map(item => [
            item.Name,
            item.Status
          ]);
          
          // Add table
          autoTable(doc, {
            head: [tableColumns],
            body: tableRows,
            startY: 40,
            styles: {
              fontSize: 9,
              cellPadding: 3,
            },
            headStyles: {
              fillColor: [63, 81, 181], // Material Blue
              textColor: 255,
              fontStyle: 'bold'
            },
            alternateRowStyles: {
              fillColor: [245, 245, 245]
            },
            margin: { top: 40 }
          });
          
          // Convert to blob
          const pdfBlob = doc.output('blob');
          
          await this.saveFile(pdfBlob, fileName, 'PDF files', {
            'application/pdf': ['.pdf']
          });
        }
        
        private async saveFile(
          blob: Blob, 
          fileName: string, 
          description: string, 
          accept: Record<string, string[]>
        ): Promise<void> {
          // Check if File System Access API is supported
          if ('showSaveFilePicker' in window) {
            try {
              const fileHandle = await (window as any).showSaveFilePicker({
                suggestedName: fileName,
                types: [{
                  description: description,
                  accept: accept
                }]
              });
              
              const writable = await fileHandle.createWritable();
              await writable.write(blob);
              await writable.close();
              this.ClosePopup()
              //console.log('File saved successfully!');
            } catch (error) {
              if (error.name !== 'AbortError') {
                console.error('Error saving file:', error);
                // Fallback to FileSaver
                FileSaver.saveAs(blob, fileName);
              }
            }
          } else {
            // Fallback for browsers that don't support File System Access API
            FileSaver.saveAs(blob, fileName);
          }
        }
        

        openAnyModal(modal){
       
        const configs = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: ' modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
            animated: false
        };
        this.modalRef = this.modalService.show(modal, configs);
    }






    // import part 

       @ViewChild('importModal', { static: true }) importModal: TemplateRef<any>;
    //@ViewChild('fileInput') fileInput: ElementRef;
    
    // Properties for import functionality
    selectedFile: File | null = null;
    isProcessing = false;
    importCompleted = false;
    progressPercentage = 0;
    processedItems = 0;
    totalItems = 0;
    batchSize = 50; // Number of items to process in each batch
      
    importData: any[] = [];
    errorItems: any[] = [];
    validItems: any[] = [];
      
    private processingTimeout: any;
    private isCancelled = false;
    
    
    // Method to open the import modal
    openImportModal() {
      this.resetImportState();
      const configs = {
        keyboard: false,
        ignoreBackdropClick: true,
        class: 'modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
        animated: false
      };
      this.modalRef = this.modalService.show(this.importModal, configs);
    }
    
    // Method to close the import modal
    closeImportModal(): void {
      if (this.isProcessing) {
        if (confirm('Import is in progress. Are you sure you want to cancel?')) {
          this.cancelImport();
        } else {
          return;
        }
      }
      this.modalRef?.hide();
      this.resetImportState();
    }
    
    // Reset import state
    resetImportState(): void {
      this.selectedFile = null;
      this.isProcessing = false;
      this.importCompleted = false;
      this.progressPercentage = 0;
      this.processedItems = 0;
      this.totalItems = 0;
      this.importData = [];
      this.errorItems = [];
      this.validItems = [];
      this.isCancelled = false;
    }
    
    // Handle file selection
    onFileSelected(event: any): void {
      //debugger
      const file: File = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        
        const reader: FileReader = new FileReader();
        
        reader.onload = (e: any) => {
          try {
            const data: Uint8Array = new Uint8Array(e.target.result);
            const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'array' });
            
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const rawData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
            
            // Transform Excel data to match your DTO format
            this.importData = (rawData as any[]).map((item, index) => ({
              groupId: null,
              groupName: item.Name || '',
               _rawStatus: item['Status']?.toString().trim(), 
              _rowIndex: index + 2 // Excel row number (accounting for header row)
            }));
            
            this.validateData();
          } catch (error) {
           // swal.fire('Error', 'Failed to parse Excel file. Please check the file format.', 'error');
    
            this.selectedFile = null;
          }
        };
        
        reader.readAsArrayBuffer(file);
      }
    }
    
    // Display file size
    getFileSizeDisplay(): string {
      if (!this.selectedFile) return '';
      
      const fileSizeKB = this.selectedFile.size / 1024;
      if (fileSizeKB < 1024) {
        return `${fileSizeKB.toFixed(2)} KB`;
      } else {
        return `${(fileSizeKB / 1024).toFixed(2)} MB`;
      }
    }
    
    // Validate imported data
  validateData(): void {
  //debugger
  this.errorItems = [];
  this.validItems = [];
  
  this.importData.forEach((item: any) => {
    debugger
    let isValid = true;
    const rowError: any = {
      rowNumber: item._rowIndex,
      groupName: item.groupName,
      error: ''
    };
    
    // Basic validation for groupName
    if (!item.groupName) {
      rowError.error += 'Name is required. ';
      isValid = false;
    }
    if (item.groupName && item.groupName.length > 100) {
      rowError.error += 'Name max length is 100 characters. ';
      isValid = false;
    }
    
    // Status validation
     const status = (item._rawStatus || '').toLowerCase();
    if (!status) {
      rowError.error += 'Active status is required. ';
      isValid = false;
    } else if (status !== 'active' && status !== 'inactive') {
      rowError.error += 'Status must be "Active" or "Inactive". ';
      isValid = false;
    } else {
      // Convert string to boolean for backend
      item.isValid = status === 'active';
    }
    
    
    // Add the item to the appropriate array
    if (isValid) {
      this.validItems.push(item);
    } else {
      this.errorItems.push(rowError);
    }
  });
}
    // Start the import process
    startImport(): void {
      //debugger
      if (this.importData.length === 0) {
       // swal.fire('Error', 'No data to import.', 'error');
    
        return;
      }
    
      if(this.validItems.length ===0){
        this.newMessage(229,'');
    
        return;
      }
      
      const dataToImport = this.errorItems.length > 0 ? this.validItems : this.importData;
      this.totalItems = dataToImport.length;
      this.processedItems = 0;
      this.progressPercentage = 0;
      this.isProcessing = true;
      this.isCancelled = false;
      
      // Process in batches to avoid UI freezing
     
      this.processBatch(dataToImport, 0);
    }
    
    processBatch(data: any[], startIndex: number): void {
      if (this.isCancelled) return;
    
      const endIndex = Math.min(startIndex + this.batchSize, data.length);
      const batch = data.slice(startIndex, endIndex);
    
      this.saveCapacitiesBatch(batch).then((response) => {
        // ✅ Update processedItems using backend-confirmed data
        this.processedItems += response?.data?.length || 0;
    
        this.progressPercentage = Math.round((this.processedItems / this.totalItems) * 100);
    
        if (endIndex < data.length && !this.isCancelled) {
          this.processingTimeout = setTimeout(() => {
            this.processBatch(data, endIndex);
          }, 100);
        } else if (!this.isCancelled) {
          this.completeImport();
        }
      }).catch((error) => {
        swal.fire('Import Error', 'Error saving batch: ' + error.message, 'error');
        this.isProcessing = false;
      });
    }
    
    // Save a batch of fixed assets
    saveCapacitiesBatch(batch: any[]): Promise<Result<any[], any>> {
      return new Promise((resolve, reject) => {
        this.userservice.addUserGroupsbatch(batch).subscribe({
          next: (response: Result<any[], any>) => {
            // Optionally update UI list here
            if (this.dataSource && this.dataSource.data && response?.data?.length) {
              this.dataSource.data = [...this.dataSource.data, ...response.data];
            }
    
            resolve(response); //  Resolve with the response
          },
          error: (err) => reject(err)
        });
      });
    }
    
    // Continue with only valid items
    continueWithValidItems(): void {
      if (this.validItems.length === 0) {
        swal.fire('Error', 'No valid items to import.', 'error');
    
        return;
      }
      
      this.startImport();
    }
    
    // Cancel the import process
    cancelImport(): void {
      this.isCancelled = true;
      if (this.processingTimeout) {
        clearTimeout(this.processingTimeout);
      }
      this.isProcessing = false;
      //swal.fire('Import Cancelled', 'Import cancelled.', 'warning');
    
    }
    
    // Complete the import process
    completeImport(): void {
      this.isProcessing = false;
      this.importCompleted = true;
      //swal.fire('Import Complete', `Successfully imported ${this.processedItems} items.`, 'success');
    
      
      // Refresh your data if needed
      this.getList();
      //this.loadData(); // Call your existing method to reload the data
    }
    
    // Update your import button click handler
    onImportClick(): void {
      this.openImportModal();
    }

      ngAfterViewInit() {
        this.getTableConfig();
    }


     @ViewChild('userGroups', { read: MatTable }) UserGroupsTable: MatTable<any>;
        @ViewChild('userGroupsRow') MatRow!: MatHeaderRow;
      getTableConfig() {
        this.baseService
            .post(`GridConfig/GetGridCongif`, this.Gridcongid)
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                if (result.data != null && result.data.length > 0) {
                    let list = result.data
                    this.MatRow = result.data.map((obj) => obj.col);
                    //console.log(this.MatRow.nativeElement.getAttribute('matHeaderRowDef'))
                    console.log(this.UserGroupsTable._contentHeaderRowDefs.toArray());
                    this.UserGroupsTable._contentHeaderRowDefs.toArray()[0].columns = list.map((obj) => obj.col);
                    this.UserGroupsTable._contentRowDefs.toArray()[0].columns = list.map((obj) => obj.col);

                    this.UserGroupsTable.renderRows();
                }
            });
    }

    
   updateNewCol(event) {
  if (event) {
    // Always start with the "select" column
    let visibleCols = event.filter((e) => e.isShowen === true && e.col !== 'select');
    let colKeys = ['select', ...visibleCols.map((obj) => obj.col)];

    this.MatRow = colKeys;

    if (this.UserGroupsTable?._contentHeaderRowDefs?.length) {
      this.UserGroupsTable._contentHeaderRowDefs.toArray()[0].columns = colKeys;
    }

    if (this.UserGroupsTable?._contentRowDefs?.length) {
      this.UserGroupsTable._contentRowDefs.toArray()[0].columns = colKeys;
    }

    this.UserGroupsTable.renderRows();
  }
}



      showDialog: boolean = false;

    toggleGridPopup(): void {
  this.showDialog = !this.showDialog;
}
 
    

}

  export interface Result<T, K> {
  isSuccess: boolean;
  errorCode: number;
  message: string;
  messageType: string;
  data: T | null;
  lookupData?: K;
}

